import { render, staticRenderFns } from "./BaseInputFileGroupModal.vue?vue&type=template&id=b7f3efd2&scoped=true&"
import script from "./BaseInputFileGroupModal.vue?vue&type=script&lang=js&"
export * from "./BaseInputFileGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputFileGroupModal.vue?vue&type=style&index=0&id=b7f3efd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f3efd2",
  null
  
)

export default component.exports